import { render, staticRenderFns } from "./Selecao.vue?vue&type=template&id=62380f56"
import script from "./Selecao.vue?vue&type=script&lang=js"
export * from "./Selecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports